<template>
  <div class="admin-index">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>导航页面</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-divider content-position="left"></el-divider>
      <div class="content-item">
        待审核游客申请数量 <em>{{indexForm.visdata}}</em> <a class="logout-link" href="/admin/vav">-->游客申请审核</a>
      </div>
      <el-divider content-position="left"></el-divider>
      <div class="content-item">
        待审核用户申请数量 <em>{{indexForm.usrdata}}</em> <a class="logout-link" href="/admin/userv">-->用户申请审核</a>  
      </div>
      <el-divider content-position="left"></el-divider>
      <div class="content-item">
        最后一个提案数据结束时间 <em>{{indexForm.lastproptime}}</em> <a class="logout-link" href="/admin/proposal">-->提案数据维护</a>  
      </div>
      <div class="content-item">
        最后一个GRB数据结束时间 <em>{{indexForm.lastgrbtime}}</em> <a class="logout-link" href="/admin/grbdata">-->GRB数据维护</a>  
      </div>
      <div class="content-item">
        最后一个SEM数据结束时间 <em>{{indexForm.lastsemtime}}</em> <a class="logout-link" href="/admin/semdata">-->SEM数据维护</a>
      </div>
      <el-divider content-position="left"></el-divider>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
export default {
  name: 'usrceninfo',
  data() {
    return {
      indexForm:{
        visdata:0,
        usrdata:0,
        lastproptime:'',
        lastgrbtime:'',
        lastsemtime:'',
      },
  
    };
  },
  computed: {
    ...mapState([
      'userInfo',
      'language',
    ]),
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {

      }
      axios.post('/iapi/getindexdata', params).then((res) => {
        if (res.data.errcode === 0) {
          this.indexForm.visdata = res.data.visdata;
          this.indexForm.usrdata = res.data.usrdata;
          this.indexForm.lastproptime = res.data.lastproptime;
          this.indexForm.lastgrbtime = res.data.lastgrbtime;
          this.indexForm.lastsemtime = res.data.lastsemtime;
        } else {
          this.$message.error('数据不存在');
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.admin-index {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
  padding: 16px 24px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 10px;
    margin-bottom: 10px;
}
.admin-path {
  margin-bottom: 16px;
}
.content-item {
  font-size: 14px;
  color: #606266;
  height: 32px;
  line-height: 32px;
  a {
    color: #0058a3;
  }
  em {
    color: #c00;
    font-weight: 500;
    font-style: normal;
  }
}
</style>